import { InfoOutlined } from '@mui/icons-material'
import { Box, Card, CardContent, CardHeader, Divider, Grid, Tooltip, Typography } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function AdditionalInfoCard({ selectedCompany }) {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={t("shippingDetails.additional.title")} />
            <Divider />
            <CardContent>
                <Grid container spacing={2}>
                    {
                        !!selectedCompany?.estimatedPickupDate &&
                        <Grid item xs={12} sm={6}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.additional.expectedPickupby")}
                                    </Typography>
                                    <Tooltip title={t("shippingDetails.additional.expectedPickupbyInfo")} placement='top'>
                                        <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                    </Tooltip>
                                </Box>
                                <Typography variant="subtitle2">
                                    {moment(selectedCompany?.estimatedPickupDate).format("dddd DD.MM.YYYY")}
                                </Typography>
                            </Box>
                        </Grid>
                    }
                    {
                        !!selectedCompany?.estimatedDeliveryDate &&
                    <Grid item xs={12} sm={6}>
                        <Box display="flex" flexDirection="column">
                            <Box display="flex" alignItems="center" mb={1}>
                                <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                    {t("shippingDetails.additional.expectedDeliveryAfterPickup")}
                                </Typography>
                                <Tooltip title={t("shippingDetails.additional.expectedPickupbyInfo")} placement='top'>
                                    <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                </Tooltip>
                            </Box>
                            <Typography variant="subtitle2">
                                {moment(selectedCompany?.estimatedDeliveryDate).format("dddd DD.MM.YYYY")}
                            </Typography>
                        </Box>
                    </Grid>
                    }
                    <Grid item xs={12} sm={12}>
                        <Divider />
                    </Grid>
                    {
                        (!!selectedCompany?.estimatedDropOffDate && !!selectedCompany?.estimatedDropOffDeliveryDate && !!selectedCompany?.dropOffCutOff) &&
                        <Grid item xs={12} sm={12}>
                            <Box display="flex" flexDirection="column">
                                <Box display="flex" alignItems="center" mb={1}>
                                    <Typography fontWeight="bold" variant="body2" sx={{ color: "text.lighter" }}>
                                        {t("shippingDetails.additional.expectedDeliveryAfterDropOff")}
                                    </Typography>
                                    {/* <Tooltip title={t("shippingDetails.additional.CODPercentageInfo")} placement='top'>
                                    <InfoOutlined sx={{ ml: 1, color: "text.lighter" }} fontSize="small" />
                                </Tooltip> */}
                                </Box>
                                <Typography variant="subtitle2">
                                    {t("deliveryAfterDropoff",
                                        {
                                            from: selectedCompany?.estimatedDropOffDate,
                                            to: selectedCompany?.estimatedDropOffDeliveryDate,
                                            time: selectedCompany?.dropOffCutOff
                                        })
                                    }
                                </Typography>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </CardContent>
        </Card>
    )
}
